import { useEffect, useRef, useState } from "react";

export const useInView = (threshold = 0.15) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        const big = entry.intersectionRect.height >= window.innerHeight * 0.2;
        if (entry.isIntersecting && (entry.intersectionRatio >= threshold || big)) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: [0, 0.05, 0.1, threshold], rootMargin: "0px 0px -60px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, inView];
};

export const Reveal = ({ children, delay = 0, className = "", variant, ...rest }) => {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`reveal ${variant === "tech" ? "reveal-tech" : ""} ${inView ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </div>
  );
};
